import React, { memo, useCallback, useState } from 'react'
import { useTranslation } from 'react-i18next'
import ImageRule from '@National/images/rule-bg.webp'
import ImageRuleClose from '@National/images/rule-close.webp'
import './index.scss'
import clsx from 'clsx'
import { resetScroll, stopScroll } from '@/utils/tool'

function index() {
  const { t } = useTranslation()
  const [viewDialog, setViewDialog] = useState(false)

  const handleViewDialog = useCallback((view: boolean) => {
    if (view) {
      stopScroll()
    } else {
      resetScroll()
    }
    setViewDialog(view)
  }, [])

  return (
    <>
      <div className="cmp-rule" onClick={() => handleViewDialog(true)}>
        <img className="cmp-rule__bg" src={ImageRule} />
        <span>{t('Common.Rule')}</span>
      </div>
      <div
        className={clsx('cmp-rule__dialog', {
          hide: !viewDialog
        })}
      >
        <div className="cmp-rule__dialog-content">
          <span className="cmp-rule__dialog-title">{t('Common.Rule')}</span>
          <img className="cmp-rule__dialog-close" src={ImageRuleClose} onClick={() => handleViewDialog(false)} />
          <div className="cmp-rule__dialog-list">
            <div className='cmp-rule__dialog-info'>{t('National.RuleInfo', { APP: process.env.REACT_APP_DISPLAY_NAME })}</div>
            {new Array(4).fill(0).map((_, i) => (
              <div className="cmp-rule__dialog-item" key={i}>
                {t(`National.Rule${i + 1}`, { APP: process.env.REACT_APP_DISPLAY_NAME })}
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  )
}

export default memo(index)
